import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  KeyboardView,
  Wrapper,
  Copy,
  Title,
  Button,
  Row,
  Icon
} from "app/NativeComponents/common";

import {
  /*mobile*/
  setPaymentPage,
  togglePaymentPage
} from "app/NativeActions";

const queryString = require("query-string");

class PurchaseEngine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_content: null,
      onboarding_content_loading: true
    };
  }

  componentDidUpdate(prevProps) {}

  componentDidMount() {
    let engine_slug = null;
    let tier = null;
    let frequency = null;
    let extra_fee = null;
    let extra_fee_text = null;

    if (this.props.location) {
      const parsed = queryString.parse(this.props.location.search);
      if (!!parsed.engine) {
        engine_slug = parsed.engine;
      }
      if (!!parsed.tier) {
        tier = parsed.tier;
      }

      if (!!parsed.frequency) {
        frequency = parsed.frequency;
      }

      if (!!parsed.extra_fee) {
        extra_fee = parsed.extra_fee;
      }
      if (!!parsed.extra_fee_text) {
        extra_fee_text = parsed.extra_fee_text;
      }

      if (!!engine_slug && !!tier && !!frequency) {
        this.props.setPaymentPage({
          engine_slug: engine_slug,
          tier: tier,
          frequency: frequency,
          extra_fee,
          extra_fee_text,
          title: "Confirm Payment"
        });
        this.props.togglePaymentPage(true);
      }
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = ({ auth }) => {
  const { token, user } = auth;

  return {
    token,
    user
  };
};

export default connect(mapStateToProps, {
  /*mobile*/
  setPaymentPage,
  togglePaymentPage
})(PurchaseEngine);
